import JwtService from "./jwtService";

export default function useJwt(axiosIns, jwtOverrideConfig) {
  const jwt = null;

  return {
    jwt,
  };
}
